<template>
  <div class="app-container">
    <loading :show="loadingShow"></loading>
    <Header></Header>
    <img
      v-if="!loadingShow"
      class="right-bg"
      :src="
        isMobile
          ? nowCityTravel.showImagesRealPath_new
            ? nowCityTravel.showImagesRealPath_new
            : require('../../assets/images/cityTravel/right-img-wap.png')
          : nowCityTravel.shareImageRealPath_new
          ? nowCityTravel.shareImageRealPath_new
          : require('../../assets/images/cityTravel/right-img-pc.png')
      "
      alt=""
    />
    <div v-if="!loadingShow" class="top">
      <div class="title">{{ nowCityTravel.officeName }}</div>
      <div class="s-title">{{ nowCityTravel.content | removeTag }}</div>
    </div>
    <div class="session-content">
      <div class="search-box">
        <div
          class="select-box flex flex-wrap align-center"
          :class="isMobile ? 'justify-around' : 'justify-center'"
        >
          <div class="select-name">
            <van-field
              v-model="search.name"
              placeholder="活动名称"
              :clearable="isMobile"
            />
          </div>
          <div class="select-city">
            <el-select
              style="width: 100%; height: 100%"
              v-model="search.city"
              @change="selectOptionWap"
              :popper-append-to-body="false"
            >
              <el-option
                style="
                  width: 100%;
                  height: 40px;
                  padding-left: 14px;
                  color: #000000;
                "
                class="no-option flex align-center"
                v-for="item in nowCityDict.child"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="select-date flex align-center justify-around"
            @click="isMobile ? didClick_date() : ''"
          >
            <div class="start-date">
              <van-field
                :disabled="true"
                v-model="search.startDate"
                :right-icon="
                  require('../../assets/images/cityTravel/date-start.png')
                "
                placeholder="开始时间"
              />
            </div>
            <div class="text">到</div>
            <div class="end-date">
              <van-field
                :disabled="true"
                v-model="search.endDate"
                :right-icon="
                  require('../../assets/images/cityTravel/date-end.png')
                "
                placeholder="结束时间"
              />
            </div>
            <el-date-picker
              v-if="!isMobile"
              v-model="starnAndEndDate"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: 1px solid #000;
                opacity: 0;
              "
              :type="'daterange'"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="selectDate"
            >
            </el-date-picker>
          </div>
          <van-calendar
            style="height: 60vh"
            v-model="dateShow"
            type="range"
            :row-height="70"
            :show-title="false"
            @confirm="selectDate"
          />
          <div
            v-if="!isMobile"
            class="search-btn flex align-center justify-center cs"
            @click="didClick_submit"
          >
            <img class="icon" src="../../assets/images/cityTravel/seach.png" />
            <div class="text">搜索</div>
          </div>
          <div
            v-if="!isMobile"
            class="reset-btn flex align-center justify-center cs"
            @click="didClick_reset"
          >
            <img class="icon" src="../../assets/images/cityTravel/reset.png" />
            <div class="text">重置</div>
          </div>
        </div>
        <div class="btns flex justify-center" v-if="isMobile">
          <div
            class="search-btn flex align-center justify-center cs"
            @click="didClick_submit"
          >
            <img class="icon" src="../../assets/images/cityTravel/seach.png" />
            <div class="text">搜索</div>
          </div>
          <div
            class="reset-btn flex align-center justify-center cs"
            @click="didClick_reset"
          >
            <img class="icon" src="../../assets/images/cityTravel/reset.png" />
            <div class="text">重置</div>
          </div>
        </div>
        <div
          class="type-box flex flex-direction justify-between"
          :class="isMobile ? '' : 'align-center'"
          v-for="(type, index) in btns"
          :key="index"
        >
          <div
            class="title"
            :class="{ 'title-isNoChrome': !isChrome && !isSafari }"
          >
            {{ type.name }}
          </div>
          <div class="type-btns flex align-center">
            <div
              class="type-btn flex align-center justify-center cs"
              v-for="(item, index2) in type.btnList"
              :key="index2"
              @click="didClick_type(type, index, item)"
              :class="{ 'type-btn-select': item.isSelect }"
            >
              {{ item.name }}
            </div>
            <div class="box-35">--</div>
          </div>
        </div>
      </div>
      <div class="session-list" v-if="sessionList.length > 0">
        <div
          class="session-box"
          v-for="(item, index) in sessionList"
          :key="index"
        >
          <img
            class="img"
            :src="
              item.i_listDiagram_new
                ? item.i_listDiagram_new
                : require('../../assets/images/cityTravel/img1.jpg')
            "
            alt="暂无图片"
          />
          <div class="detail flex justify-between">
            <div class="desc flex flex-direction justify-between">
              <div
                class="title ellipsis-1"
                :class="{
                  cs: !item.i_isSeeDeatil || item.i_isSeeDeatil[0] != '否',
                }"
                @click="
                  !item.i_isSeeDeatil || item.i_isSeeDeatil[0] != '否'
                    ? didClick_Detail(item)
                    : ''
                "
              >
                {{ item.name | removeTag }}
              </div>
              <div
                v-if="!isMobile"
                class="describe ellipsis-2"
                v-html="item.intro"
              >
                <!--                {{ item.i_meetTitle }}-->
              </div>
              <div class="add-date flex">
                <div class="address flex align-center">
                  <img
                    class="icon"
                    src="../../assets/images/agenda/address.png"
                  />
                  <div class="text ellipsis-1">
                    {{ item.i_office[0] }}-{{ item.i_office[1] }}
                  </div>
                </div>
                <div class="date flex align-center">
                  <img class="icon" src="../../assets/images/agenda/time.png" />
                  <div class="text ellipsis-1" v-if="item.i_fuzzyDate">
                    {{ item.i_fuzzyDate }}
                  </div>
                  <div class="text" v-else>
                    {{
                      isMobile ? item.startAndEndDate_wap : item.startAndEndDate
                    }}
                  </div>
                </div>
              </div>
              <div class="qd-add flex align-center">
                <img
                  class="icon"
                  src="../../assets/images/agenda/address.png"
                />
                <div class="text ellipsis-1">会议地址：{{ item.hotel }}</div>
              </div>
            </div>
            <div class="btn flex flex-direction align-center justify-start">
              <div
                class="linkDetail cs"
                @click="didClick_Detail(item)"
                v-if="!item.i_isSeeDeatil || item.i_isSeeDeatil[0] != '否'"
              >
                查看详情 >>
              </div>
              <div
                class="linkDetail"
                v-if="
                  item.i_isSeeDeatil &&
                  item.i_isSeeDeatil[0] == '否' &&
                  item.status != '已结束'
                "
              >
                敬请期待
              </div>
              <div
                v-if="item.status == '报名中'"
                v-show="item.i_signUpId"
                class="btn-text flex align-center justify-center isSignUp cs"
                @click="didClick_signUp(item.i_signUpId, item.name)"
              >
                立即报名
              </div>
              <div
                v-if="item.status == '已结束'"
                class="btn-text flex align-center justify-center"
              >
                已结束
              </div>
            </div>
          </div>
        </div>
      </div>
      <not-data v-if="sessionList.length === 0"></not-data>
    </div>
    <cook-tip></cook-tip>
    <foot></foot>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Foot from "../../components/Foot";
import CookTip from "../../components/CookTip";
import { staticApi } from "../../services";
import { mapState } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import { seminarAPI } from "@/services/modules/seminar";
import Cookie from "js-cookie";
import { pinyin } from "pinyin-pro";
// import testData from "../../plugins/testData";
export default {
  name: "cityTravelList",
  filters: {
    removeTag(str) {
      str = str.replace(/<\/?[^>]*>/g, ""); //匹配所有html标签
      str = str.replace(/<p[^>]*>/g, '<p class="tag-class">'); //去除标签内所有属性，并设置自定义类名
      str = str.replace(/(\n)/g, ""); //去除换行
      str = str.replace(/\s+style="[^"]*"/g, ""); //去除style样式
      str = str.replace(/&nbsp;/gi, ""); //去除空格
      return str;
    },
  },
  data() {
    return {
      rawData: null, //原始数据
      sessionList: [],
      sedate: "",
      dateShow: false,
      selectCity: "",
      nowCityDict: {
        child: [],
      },
      btns: [
        {
          name: "活动类型",
          isCheckBox: true,
          btnList: [],
        },
        {
          name: "行业",
          isCheckBox: true,
          btnList: [],
        },
        {
          name: "产品",
          isCheckBox: true,
          btnList: [],
        },
        {
          name: "活动状态",
          isCheckBox: false,
          btnList: [
            {
              name: "报名中",
            },
            {
              name: "已结束",
            },
            {
              name: "敬请期待",
            },
          ],
        },
      ],
      search: {
        name: "",
        city: "",
        startDate: "",
        endDate: "",
        activity: [],
        product: [],
        industry: [],
        status: "",
      },
      starnAndEndDate: "", //pc端 时间选择器 使用数据
      nowCityTravel: null, //当前办事出详细信息
      loadingShow: true,
      isChrome: true,
      isSafari: false,
    };
  },
  components: {
    Header,
    Foot,
    CookTip,
    notData: () => import("../../components/agenda/notData.vue"),
  },
  computed: mapState({
    isMobile: (state) => !!state.isMobile,
  }),
  created() {},
  mounted() {
    this.isChrome =
      window.navigator.userAgent.toLowerCase().indexOf("chrome") > 0;
    this.isSafari =
      window.navigator.userAgent.toLowerCase().indexOf("safari") > 0;
    if (
      this.$route.query &&
      this.$route.query.articleID &&
      this.$route.query.cityName
    ) {
      //获取办事处信息
      this.getOffice(this.$route.query.articleID);
      //获取分会场列表
      this.getSeminarList(this.$route.query.cityName);
      //办事处下面的城市 字典值
      this.getDICT(this.$config.cityTravelDictId).then((res) => {
        res.forEach((item) => {
          if (item.name == this.$route.query.cityName) {
            item.child.unshift({
              name: "全部",
            });
            this.nowCityDict = item;
          }
        });
      });
      //筛选类型 字典
      this.getDICT(this.$config.cityTravelSearchTypeId).then((searchType) => {
        searchType.forEach((item) => {
          item.isSelect = false;
        });
        this.btns[0].btnList = searchType;
      });
      //筛选 产品
      this.getDICT(this.$config.cityTravelSearchIndustryId).then(
        (searchType) => {
          searchType.forEach((item) => {
            item.isSelect = false;
          });
          this.btns[1].btnList = searchType;
        }
      );
      //筛选 行业
      this.getDICT(this.$config.cityTravelSearchpProductId).then(
        (searchType) => {
          searchType.forEach((item) => {
            item.isSelect = false;
          });
          this.btns[2].btnList = searchType;
        }
      );
    }
    if (this.$route.query && this.$route.query.utm_source) {
      Cookie.set("utm_source", this.$route.query.utm_source);
    }
  },
  methods: {
    //获取办事处信息
    getOffice(articleID) {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.onlineSeminarId}/article/${articleID}.json`
        )
        .then((res) => {
          let nowCityTravel = res.content;
          nowCityTravel.officeName = "";
          nowCityTravel.name = "";
          nowCityTravel.value = "";
          nowCityTravel.en = "";
          nowCityTravel.sessions = [];
          if (nowCityTravel.title.indexOf("|") > -1) {
            nowCityTravel.name = nowCityTravel.title.substring(
              0,
              nowCityTravel.title.indexOf("|")
            );
            nowCityTravel.en = pinyin(
              nowCityTravel.title.substring(
                0,
                nowCityTravel.title.indexOf("|")
              ),
              {
                toneType: "none",
              }
            ).replace(/\s+/g, "");
            nowCityTravel.officeName = nowCityTravel.title.substring(
              nowCityTravel.title.indexOf("|") + 1,
              nowCityTravel.title.length
            );
          }
          if (nowCityTravel.title.indexOf("||") > -1) {
            nowCityTravel.value = nowCityTravel.title.substring(
              nowCityTravel.title.indexOf("|") + 1,
              nowCityTravel.title.indexOf("||")
            );
            nowCityTravel.officeName = nowCityTravel.title.substring(
              nowCityTravel.title.indexOf("||") + 2,
              nowCityTravel.title.length
            );
          }
          nowCityTravel.shareImageRealPath_new = "";
          if (nowCityTravel.shareImageRealPath) {
            nowCityTravel.shareImageRealPath_new =
              nowCityTravel.shareImageRealPath.replace(
                /^.*\/\/hwyhw.smarket.net.cn/,
                "https://hwyhw-files.smarket.net.cn"
              );
          }
          nowCityTravel.showImagesRealPath_new = "";
          if (
            nowCityTravel.showImagesRealPath &&
            nowCityTravel.showImagesRealPath.length > 0
          ) {
            nowCityTravel.showImagesRealPath_new =
              nowCityTravel.showImagesRealPath[0].replace(
                /^.*\/\/hwyhw.smarket.net.cn/,
                "https://hwyhw-files.smarket.net.cn"
              );
          }
          this.nowCityTravel = nowCityTravel;
          setTimeout(() => {
            this.loadingShow = false;
          }, 200);
        })
        .catch((err) => {
          console.error("获取列表失败", err);
          setTimeout(() => {
            this.loadingShow = false;
          }, 200);
        });
    },
    //获取会场列表
    getSeminarList(cityName) {
      seminarAPI
        .getSubSeminarList_onLine()
        .then((res) => {
          let sessionsListTemp = this.sessionsList_o;
          if (res.result == 0) {
            let SeminarList = res.content.items;
            //拿出伙伴百城行的
            let now = SeminarList.filter((item) => {
              if (
                item.i_type &&
                item.i_type[0] == "伙伴百城行" &&
                item.i_office[0] == cityName
              ) {
                return item;
              }
            });
            // let now = testData;
            // console.log("模拟数据", now);
            now.forEach((item2) => {
              if (
                dayjs(item2.startTime * 1000).format("YYYY/MM/DD") ==
                dayjs(item2.endTime * 1000).format("YYYY/MM/DD")
              ) {
                //日期相同只取开始时间
                item2.startAndEndDate = dayjs(item2.startTime * 1000).format(
                  "YYYY/MM/DD"
                );
                item2.startAndEndDate_wap = dayjs(
                  item2.startTime * 1000
                ).format("YYYY/MM/DD");
              } else {
                item2.startAndEndDate =
                  dayjs(item2.startTime * 1000).format("YYYY/MM/DD") +
                  "-" +
                  dayjs(item2.endTime * 1000).format("YYYY/MM/DD");
                item2.startAndEndDate_wap =
                  dayjs(item2.startTime * 1000).format("YYYY/MM/DD") +
                  "-" +
                  dayjs(item2.endTime * 1000).format("MM/DD");
              }
              item2.status =
                new Date().getTime() > item2.endTime * 1000
                  ? "已结束"
                  : item2.i_signUpId
                  ? "报名中"
                  : "不可报名";
              item2.isSeeDeatil =
                !item2.i_isSeeDeatil || item2.i_isSeeDeatil[0] != "否";
              //列表封面图
              item2.i_listDiagram_new = "";
              if (item2.i_listDiagram) {
                item2.i_listDiagram_new = item2.i_listDiagram.replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
            });
            // 1 查看详情+立即报名  时间正序
            // 2 敬请期待+立即报名 时间正序
            // 3 查看详情  时间正序
            // 4 敬请期待  时间正序
            // 5 已结束  时间倒叙
            let type1 = now.filter((item) => {
              return item.status == "报名中" && item.isSeeDeatil;
            });
            type1 = this.sessionSort(type1, "asc");
            console.log(" 1 查看详情+立即报名  时间正序", type1);
            let type2 = now.filter((item) => {
              return item.status == "报名中" && !item.isSeeDeatil;
            });
            type2 = this.sessionSort(type2, "asc");
            console.log(" 2 敬请期待+立即报名 时间正序", type2);
            let type3 = now.filter((item) => {
              return item.status == "不可报名" && item.isSeeDeatil;
            });
            type3 = this.sessionSort(type3, "asc");
            console.log(" 3 查看详情  时间正序", type3);
            let type4 = now.filter((item) => {
              return item.status == "不可报名" && !item.isSeeDeatil;
            });
            type4 = this.sessionSort(type4, "asc");
            console.log("4 敬请期待  时间正序", type4);
            let type5 = now.filter((item) => {
              return item.status == "已结束";
            });
            type5 = this.sessionSort(type5, "desc");
            console.log("5 已结束  时间倒叙", type5);
            now = type1.concat(type2.concat(type3.concat(type4.concat(type5))));
            this.rawData = _.cloneDeep(now);
            this.sessionList = now;
          }
        })
        .catch((err) => {
          console.log("获取分会场列表失败", err);
        });
    },
    //分会场列表排序
    sessionSort(list, type) {
      console.log(list, type);
      if (type == "desc") {
        let haveSort = list.filter((item) => {
          return item.i_meetOrder;
        });
        haveSort.sort((a, b) => {
          return b.i_meetOrder - a.i_meetOrder;
        });
        let noHaveSort = list.filter((item) => {
          return !item.i_meetOrder;
        });
        //按时间倒叙排序
        noHaveSort.sort((a, b) => {
          if (b.startTime - a.startTime !== 0) {
            return b.startTime - a.startTime;
          }
          if (b.endTime - a.endTime !== 0) {
            return b.endTime - a.endTime;
          }
          return b.createTime - a.createTime;
        });
        return haveSort.concat(noHaveSort);
      } else {
        let haveSort = list.filter((item) => {
          return item.i_meetOrder;
        });
        haveSort.sort((a, b) => {
          return b.i_meetOrder - a.i_meetOrder;
        });
        let noHaveSort = list.filter((item) => {
          return !item.i_meetOrder;
        });
        //按时间倒叙排序
        noHaveSort.sort((a, b) => {
          if (b.startTime - a.startTime !== 0) {
            return a.startTime - b.startTime;
          }
          if (b.endTime - a.endTime !== 0) {
            return a.endTime - b.endTime;
          }
          return a.createTime - b.createTime;
        });
        return haveSort.concat(noHaveSort);
      }
    },
    /**
     * @description 获取字典  办事处字典
     * @returns {*}
     */
    getDICT(dictId) {
      // 内容分类
      return staticApi
        .request(`/${this.$config.tenantId}/dic/list/${dictId}.json`)
        .then((res) => {
          if (res.result == 0) {
            let dictInfo = res.content[dictId];
            for (let item of dictInfo) {
              if (Object.values(item.child)[0]) {
                item.child = Object.values(item.child)[0];
                const loop = (list) => {
                  list.forEach((i) => {
                    if (Object.values(i.child)[0]) {
                      i.child = Object.values(i.child)[0];
                      loop(i.child);
                    }
                  });
                };
                loop(item.child);
              }
            }
            return dictInfo;
          }
        })
        .catch((error) => {
          console.log("获取字典值失败", error);
          return [];
        });
    },
    selectDate(date) {
      if (date.length == 2) {
        this.search.startDate = dayjs(date[0]).format("YYYY-MM-DD");
        this.search.endDate = dayjs(date[1]).format("YYYY-MM-DD");
      }
      this.dateShow = false;
    },
    //WAP 下拉选择
    selectOptionWap(e) {
      this.search.city = e;
    },
    //选择时间
    didClick_date() {
      this.dateShow = true;
    },
    //提交
    didClick_submit() {
      //埋码
      window._hw("send", "action", "branch_venue_page_search_click", {
        meeting_name: this.nowCityTravel.officeName,
        city: this.nowCityTravel.name,
        venue_name: this.search.name,
      });
      this.session_Seache();
    },
    //重置
    didClick_reset() {
      this.search = {
        name: "",
        city: "",
        startDate: "",
        endDate: "",
        activity: [],
        product: [],
        industry: [],
      };
      this.reTypeSearch();
      this.sessionList = _.cloneDeep(this.rawData); //赋值
    },
    //点击类型
    didClick_type(type, idx, option) {
      if (type.isCheckBox) {
        let selArr = [];
        type.btnList.forEach((item) => {
          if (item.name == option.name) {
            item.isSelect = !item.isSelect;
          }
          if (item.isSelect) {
            selArr.push(item.name);
          }
        });
        if (type.name == "活动类型") {
          this.search.activity = selArr;
        }
        if (type.name == "产品") {
          this.search.product = selArr;
        }
        if (type.name == "行业") {
          this.search.industry = selArr;
        }
      } else {
        let isSel = false;
        type.btnList.forEach((item) => {
          if (item.name == option.name) {
            item.isSelect = !item.isSelect;
            if (item.isSelect) isSel = true;
          } else {
            item.isSelect = false;
          }
        });
        this.search.status = isSel ? option.name : "";
      }
      this.btns[idx].btnList = type.btnList;
      this.session_Seache();
    },
    //类型筛选重置
    reTypeSearch() {
      let btns = this.btns;
      btns.forEach((item) => {
        item.btnList.forEach((item2) => {
          item2.isSelect = false;
        });
      });
      this.btns = btns;
    },
    //搜索
    session_Seache() {
      let rawData = _.cloneDeep(this.rawData);
      let search = this.search;
      search.name = search.name.replace(/\s+/g, ""); //去除空格
      //若判断值都为空  重新赋值
      if (
        search.activity.length == 0 &&
        search.product.length == 0 &&
        search.industry.length == 0 &&
        search.city == "" &&
        search.name == "" &&
        search.endDate == "" &&
        search.startDate == "" &&
        search.status == ""
      ) {
        this.sessionList = rawData; //赋值
        return;
      }
      let noDateSeacheList = rawData.filter((item) => {
        if (item.i_fuzzyDate) {
          if (search.endDate && search.startDate) {
            //若有时间搜索  排除未定时间的
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      });
      let nowSeacheList = noDateSeacheList.filter((item) => {
        let haveName = false;
        let haveCity = false;
        let haveDate = false;
        let haveType = false;
        let haveProduct = false;
        let haveIndustry = false;
        let haveStatus = false;
        //名称是否有匹配的
        if (search.name) {
          if (item.name.replace(/\s+/g, "").indexOf(search.name) > -1) {
            haveName = true;
          }
        } else {
          haveName = true;
        }
        //城市是否有匹配的
        if (search.city) {
          if (search.city == "全部") {
            haveCity = true;
          } else {
            if (item.i_office[1] == search.city) {
              haveCity = true;
            }
          }
        } else {
          haveCity = true;
        }
        //日期是否有匹配的
        if (search.startDate && search.endDate) {
          if (
            item.startTime * 1000 > new Date(search.startDate).getTime() &&
            item.startTime * 1000 <
              new Date(search.endDate).getTime() + 86400000
          ) {
            haveDate = true;
          }
        } else {
          haveDate = true;
        }
        //类型是否有匹配的
        if (search.activity && search.activity.length > 0) {
          //有产品类型
          if (item.i_activityType.length > 0) {
            let newarr = item.i_activityType.filter(function (n) {
              return search.activity.indexOf(n) !== -1;
            });
            haveType = newarr.length > 0;
          } else {
            //无活动类型匹配
            haveType = false;
          }
        } else {
          haveType = true;
        }
        // if (search.type) {
        //   if (item.i_activityType[0] == search.type) {
        //     haveType = true;
        //   }
        // } else {
        //   haveType = true;
        // }
        //产品是否匹配
        if (search.product && search.product.length > 0) {
          //有产品类型
          if (item.i_productType.length > 0) {
            let newarr = item.i_productType.filter(function (n) {
              return search.product.indexOf(n) !== -1;
            });
            haveProduct = newarr.length > 0;
          } else {
            //无产品类型
            haveProduct = false;
          }
        } else {
          haveProduct = true;
        }
        //行业是否匹配
        if (search.industry && search.industry.length > 0) {
          //有行业类型
          if (item.i_industryType.length > 0) {
            let newarr = item.i_industryType.filter(function (n) {
              return search.industry.indexOf(n) !== -1;
            });
            haveIndustry = newarr.length > 0;
          } else {
            //无行业类型
            haveIndustry = false;
          }
        } else {
          haveIndustry = true;
        }
        //状态是否有匹配的
        if (search.status) {
          if (search.status == "敬请期待") {
            if (!item.isSeeDeatil && item.status != "已结束") {
              haveStatus = true;
            }
          } else if (item.status == search.status) {
            haveStatus = true;
          }
        } else {
          haveStatus = true;
        }
        //逻辑判断 或与非
        if (
          haveName &&
          haveCity &&
          haveDate &&
          haveType &&
          haveProduct &&
          haveIndustry &&
          haveStatus
        ) {
          return true;
        } else {
          return false;
        }
      });
      this.sessionList = nowSeacheList; //赋值
    },
    //查看详情
    didClick_Detail(option) {
      //埋码
      window._hw(
        "send",
        "action",
        "branch_venue_page_meeting_check_detail_click",
        {
          meeting_name: this.nowCityTravel.officeName,
          city: this.nowCityTravel.name,
          venue_name: option.name,
        }
      );
      this.$router.push({
        path: "/cityTravelDetail",
        query: {
          subSeminarId: option.subSeminarId,
          meeting_name: this.nowCityTravel.officeName,
        },
      });
    },
    //报名
    didClick_signUp(id, name) {
      //埋码
      window._hw(
        "send",
        "action",
        "branch_venue_page_meeting_register_immediately_click",
        {
          meeting_name: this.nowCityTravel.officeName,
          city: this.nowCityTravel.name,
          venue_name: name,
        }
      );
      //&utm_source=xxx
      let openUrl = id;
      const utm_source = Cookie.get("utm_source");
      if (openUrl.includes("?") && typeof utm_source === "string") {
        openUrl = openUrl + "&utm_source=" + utm_source;
      } else if (!openUrl.includes("?") && typeof utm_source === "string") {
        openUrl = openUrl + "?utm_source=" + utm_source;
      }
      window.open(openUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  .app-container {
    min-height: 100%;
    width: 100%;
    background-color: #e3e9f5;
    position: relative;
    .right-bg {
      width: 100%;
      height: 435px;
      position: absolute;
      right: 0;
      top: 0px; // todo
    }
    .top {
      position: relative;
      width: 1500px;
      margin: 0 auto;
      z-index: 1;
      padding-top: 70px;

      .title {
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        font-size: $font-xxxxl;
        color: #151e26;
        margin-top: 15px;
        font-weight: 700;
        //margin-top: 108px;
      }
      .s-title {
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        font-size: $font-xxxl;
        color: #151e26;
      }
    }

    .session-content {
      z-index: 1;
      margin-top: 100px;
      width: 100%;
      background: #ffffff;
      box-shadow: inset -2px -2px 2px 1px rgba(255, 255, 255, 0.25);
      position: relative;
      .search-box {
        width: 1500px;
        //height: 150px;
        position: relative;
        left: calc((100% - 1500px) / 2);
        top: -20px;
        .select-box {
          width: auto;
          justify-self: flex-start;
          height: 100px;
          background-image: url("../../assets/images/cityTravel/select-bg-pc.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: 0 0;
          .select-name {
            width: 200px;
            height: 44px;
            margin: 0 7px;
            border-radius: 2px 2px 2px 2px;
            opacity: 0.7;
            border: 1px solid rgba(178, 191, 198, 0.9);
            ::v-deep .van-cell {
              //font-size: 14px !important;
              padding: 0;
              height: 100%;
              width: 100%;
              .van-field__body {
                height: 100%;
                width: 100%;
              }
              .van-field__control {
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                color: rgba(96, 96, 96, 0.8);
                line-height: 24px;
                font-size: 6px;
                padding-left: 6px;
                &::-webkit-input-placeholder {
                  //font-size: 10px;
                  color: rgba(96, 96, 96, 0.8);
                }

                &::-moz-placeholder {
                  /* Mozilla Firefox 19+ */

                  //font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }

                &:-moz-placeholder {
                  /* Mozilla Firefox 4 to 18 */

                  //font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }

                &:-ms-input-placeholder {
                  /* Internet Explorer 10-11 */

                  //font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }
              }
            }
          }
          .select-city {
            width: 150px;
            height: 44px;
            margin: 0 7px;
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            border: 1px solid rgba(178, 191, 198, 0.9);
            /* 自定义宽度 */
            ::v-deep .el-select {
              width: 100%;
              height: 100%;
              .el-input .el-input__inner {
                padding-left: 20px;
                border: none;
                font-size: 15px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: rgba(96, 96, 96, 0.6);
                background: rgba(255, 255, 255, 0.4);
                border: 1px solid;
                border-image: linear-gradient(
                    164deg,
                    rgba(255, 255, 255, 1),
                    rgba(235, 235, 235, 0)
                  )
                  1 1;
              }
              .el-select .el-input__inner:focus {
                border: none;
              }
              /* selecte 框的高度设置，默认是 40px*/
              .el-input {
                height: 100% !important;

                .el-input__inner {
                  height: 100% !important;
                }
                ::placeholder {
                  color: rgba(96, 96, 96, 0.7);
                }
              }

              /* 下面设置右侧按钮居中 */
              .el-input__suffix {
                /*很关键：将默认的select选择框样式清除*/
                .el-input__suffix-inner {
                  i::before {
                    width: 30px;
                  }
                }
              }
            }
            ::v-deep .el-select .el-input .el-select__caret {
              color: #b2bfc6;
              font-size: 20px;
            }
            //修改总体选项的样式 最外层
            ::v-deep .el-select-dropdown {
              padding: 20px;
              margin-top: 20px;
            }
            //修改单个的选项的样式
            ::v-deep .el-select-dropdown__item {
              background-color: transparent;
              color: #fff;
              font-size: 16px;
            }
          }
          .select-date {
            width: 350px;
            height: 46px;
            position: relative;
            .start-date {
              width: 150px;
              height: 44px;
              border: 1px solid rgba(178, 191, 198, 0.9);
            }
            .end-date {
              width: 150px;
              height: 44px;
              border: 1px solid rgba(178, 191, 198, 0.9);
            }
            ::v-deep .van-cell {
              width: 100%;
              height: 100%;
              font-size: 6px;
              padding: 0;
              padding-right: 6px;
              .van-field__body {
                width: 100%;
                height: 100%;
              }
              .van-field__control {
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                color: red;
                line-height: 24px;
                padding-left: 10px;
                &::-webkit-input-placeholder {
                  color: rgba(96, 96, 96, 0.6);
                }

                &::-moz-placeholder {
                  /* Mozilla Firefox 19+ */

                  color: rgba(96, 96, 96, 0.8);
                }

                &:-moz-placeholder {
                  /* Mozilla Firefox 4 to 18 */

                  color: rgba(96, 96, 96, 0.8);
                }

                &:-ms-input-placeholder {
                  /* Internet Explorer 10-11 */

                  color: rgba(96, 96, 96, 0.8);
                }
              }
              .van-field__right-icon {
                margin: 0;
                padding: 0;
                .van-icon {
                  .van-icon__image {
                    width: 6px;
                    height: 6px;
                  }
                }
              }
            }
          }
          .search-btn {
            width: 139px;
            height: 44px;
            margin: 0 7px;
            background: #b4251e;
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
            .icon {
              width: 17px;
              height: 17px;
              margin-right: 4px;
            }
          }
          .reset-btn {
            width: 109px;
            height: 44px;
            margin: 0 7px;
            background: #999999;
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            .icon {
              width: 15px;
              height: 16px;
              margin-right: 5px;
            }
          }
        }
        .type-box {
          width: 100%;
          flex-direction: row;
          align-items: baseline; //flex 第一行对齐
          .title {
            min-width: 80px;
            margin-right: 10px;
            font-size: 16px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
          }
          .title-isNoChrome {
            margin-top: -10px;
          }
          .type-btns {
            flex: 1;
            flex-wrap: wrap;
            height: 108%;
            scrollbar-color: transparent transparent;
            scrollbar-track-color: transparent;
            -ms-scrollbar-track-color: transparent;
            .type-btn {
              position: relative;
              width: auto;
              min-width: 110px;
              padding-left: 10px;
              padding-right: 10px;
              height: 32px;
              margin: 8px 18px 8px 0;
              font-size: 16px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              border: 1px solid #b2bfc6;
            }
            .type-btn:last-child {
              margin-right: 5px;
            }
            .type-btn:hover {
              border: 1px solid #b4251e;
            }
            .type-btn-select {
              color: #b4251e;
              border: 1px solid #b4251e;
            }
            .type-btn-select:active {
              color: #666666;
            }
          }
          .box-35 {
            display: none;
          }
          .type-btns::-webkit-scrollbar {
            display: none; /*隐藏滚动条*/
          }
        }
      }
      .session-list {
        width: 1500px;
        min-height: calc(100vh - 600px);
        margin: 0 auto;
        padding-bottom: 40px;
        display: flex;
        flex-wrap: wrap;
        .session-box {
          width: 100%;
          padding: 26px 0;
          display: flex;
          //border-bottom: 2px dashed  #999999;
          background-image: url("../../assets/images/cityTravel/foot-img.png");
          background-repeat: no-repeat;
          background-position: left bottom;
          background-size: 100% 2px;
          .img {
            width: 269px;
            height: 158px;
          }
          .detail {
            width: 1210px;
            height: 158px;
            margin-left: 22px;
            display: flex;
            .desc {
              width: 940px;
              height: 100%;
              .title {
                width: 940px;
                height: 36px;
                font-size: 18px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                font-weight: bold;
                color: #151e26;
                line-height: 30px;
              }
              .describe {
                width: 940px;
                height: 60px;
                font-size: 16px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                line-height: 30px;
              }
              .icon {
                margin-right: 6px;
              }
              .add-date {
                .address {
                  width: 120px;
                  .icon {
                    width: 16px;
                    height: 16px;
                  }
                  .text {
                    font-size: 16px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    line-height: 24px;
                  }
                }
                .date {
                  flex: 1;
                  .icon {
                    width: 15px;
                    height: 15px;
                  }
                  .text {
                    font-size: 16px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    line-height: 24px;
                  }
                }
              }
              .qd-add {
                .icon {
                  width: 15px;
                  height: 15px;
                }
                .text {
                  font-size: 16px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                  line-height: 24px;
                }
              }
            }
            .btn {
              flex: 1;
              padding-top: 40px;
              .linkDetail {
                color: #b4251e;
                text-decoration: underline;
              }
              .btn-text {
                width: 161px;
                height: 48px;
                margin-top: 20px;
                opacity: 1;
                font-size: 18px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                background: #999999;
                color: #ffffff;
              }
              .isSignUp {
                background: #b4251e;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .app-container {
    min-height: 100vh;
    width: 100%;
    background-color: #e3e9f5;
    .right-bg {
      width: 750px;
      height: 525px;
      position: absolute;
      right: 0;
      top: 0; // todo
    }
    .top {
      width: 750px;
      height: 525px;
      position: absolute;
      right: 0;
      top: 0; // todo
      padding: 250px 0 200px 80px;
      .title {
        font-size: 44px;
        font-family: Microsoft YaHei-Light;
        font-weight: 700;
        color: #151e26;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .s-title {
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        font-size: $font-xxxl;
        color: #151e26;
      }
    }

    .session-content {
      z-index: -1;
      width: 100%;
      margin-top: 410px;
      box-shadow: inset -2px -2px 2px 1px rgba(255, 255, 255, 0.25);
      background: #ffffff;
      backdrop-filter: none;
      .search-box {
        width: 100%;
        //height: 450px;
        position: relative;
        top: -40px;
        .select-box {
          width: calc(100% - 70px);
          height: 219px;
          margin-left: 35px;
          opacity: 1;
          background-image: url("../../assets/images/cityTravel/select-bg.png");
          background-size: 100% 219px;
          background-repeat: no-repeat;
          background-position: 0 0;
          background: linear-gradient(
            322deg,
            rgba(239, 239, 239, 0.8) 0%,
            rgba(255, 255, 255, 0.8) 100%
          );
          .select-name {
            width: 370px;
            height: 68px;
            border-radius: 2px 2px 2px 2px;
            opacity: 0.7;
            border: 1px solid rgba(178, 191, 198, 0.9);
            ::v-deep .van-cell {
              font-size: 14px !important;
              padding: 0;
              .van-field__control {
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                color: rgba(96, 96, 96, 0.8);
                line-height: 24px;
                font-size: 10px;
                padding-left: 10px;
                &::-webkit-input-placeholder {
                  font-size: 10px;
                  color: rgba(96, 96, 96, 0.8);
                }

                &::-moz-placeholder {
                  /* Mozilla Firefox 19+ */

                  font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }

                &:-moz-placeholder {
                  /* Mozilla Firefox 4 to 18 */

                  font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }

                &:-ms-input-placeholder {
                  /* Internet Explorer 10-11 */

                  font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }
              }
            }
          }
          .select-city {
            width: 230px;
            height: 68px;
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            border: 1px solid rgba(178, 191, 198, 0.9);
            /* 自定义宽度 */
            ::v-deep .el-select {
              width: 100%;
              height: 100%;
              .el-input .el-input__inner {
                padding-left: 20px;
                padding-right: 57px;
                border: none;
                font-size: 24px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: rgba(96, 96, 96, 0.6);
                background: rgba(255, 255, 255, 0.4);
                border: 1px solid;
                border-image: linear-gradient(
                    164deg,
                    rgba(255, 255, 255, 1),
                    rgba(235, 235, 235, 0)
                  )
                  1 1;
              }
              .el-select .el-input__inner:focus {
                border: none;
              }
              /* selecte 框的高度设置，默认是 40px*/
              .el-input {
                height: 100% !important;

                .el-input__inner {
                  height: 100% !important;
                }
                ::placeholder {
                  color: rgba(96, 96, 96, 0.7);
                }
              }

              /* 下面设置右侧按钮居中 */
              .el-input__suffix {
                /*很关键：将默认的select选择框样式清除*/
                .el-input__suffix-inner {
                  i::before {
                    width: 30px;
                  }
                }
              }
            }
            ::v-deep .el-select .el-input .el-select__caret {
              color: #b2bfc6;
              font-size: 40px;
              //height: 20px;
              height: 40px;
              width: 45px;
              text-align: center;
              margin-top: 10px;
            }
            //修改总体选项的样式 最外层
            ::v-deep .el-select-dropdown {
              padding: 20px;
              margin-top: 20px;
            }
            //修改单个的选项的样式
            ::v-deep .el-select-dropdown__item {
              background-color: transparent;
              color: #fff;
              font-size: 28px;
            }
          }
          .select-date {
            width: 625px;
            height: 68px;
            .text {
              font-size: 26px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #333333;
            }
            .start-date {
              width: 284px;
              height: 68px;
              border: 1px solid rgba(178, 191, 198, 0.9);
            }
            .end-date {
              width: 284px;
              height: 68px;
              border: 1px solid rgba(178, 191, 198, 0.9);
            }
            ::v-deep .van-cell {
              width: 100%;
              height: 100%;
              font-size: 14px !important;
              padding: 0;
              padding-right: 6px;
              .van-field__control {
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                line-height: 24px;
                font-size: 10px;
                padding-left: 10px;
                &::-webkit-input-placeholder {
                  font-size: 10px;
                  color: rgba(102, 102, 102, 1);
                }

                &::-moz-placeholder {
                  /* Mozilla Firefox 19+ */

                  font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }

                &:-moz-placeholder {
                  /* Mozilla Firefox 4 to 18 */

                  font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }

                &:-ms-input-placeholder {
                  /* Internet Explorer 10-11 */

                  font-size: 14px !important;
                  color: rgba(96, 96, 96, 0.8);
                }
              }
              .van-field__right-icon {
                .van-icon {
                  .van-icon__image {
                    width: 10px;
                    height: 10px;
                  }
                }
              }
            }
          }
          //wap端 日历
          ::v-deep .van-calendar__day--start,
          .van-calendar__day--start-end {
            background-color: #b4251e;
          }
          ::v-deep .van-calendar__day--end {
            background-color: #b4251e;
          }
          ::v-deep .van-button--danger {
            background-color: #b4251e;
            border: 1px solid #b4251e;
          }
        }
        .btns {
          width: calc(100% - 70px);
          margin-left: 35px;
          height: auto;
          padding-bottom: 30px;
          border-bottom: 1px solid rgba(153, 153, 153, 0.3);
          margin-top: 10px;
          .search-btn {
            width: 284px;
            height: 68px;
            margin-right: 26px;
            background: #b4251e;
            font-size: 24px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
            .icon {
              width: 24px;
              height: 24px;
              margin-right: 6px;
            }
          }
          .reset-btn {
            width: 137px;
            height: 68px;
            background: #999999;
            font-size: 24px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            .icon {
              width: 22.6px;
              height: 26px;
              margin-right: 6px;
            }
          }
        }
        //::v-deep .
        .type-box {
          width: 100%;
          height: 110px;
          margin-top: 18px;
          .title {
            height: 24px;
            margin-left: 35px;
            font-size: 24px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 24px;
          }
          .type-btns {
            width: 100%;
            height: 70px;
            overflow-x: scroll;
            overflow-y: hidden;
            white-space: nowrap;
            .type-btn {
              position: relative;
              width: auto;
              min-width: 220px;
              height: 60px;
              margin-right: 24px;
              font-size: 24px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              border: 1px solid #b2bfc6;
            }
            .type-btn:first-child {
              margin-left: 35px;
            }
            .type-btn:last-child {
              margin-right: 0px;
            }
            .type-btn:active {
              color: #b4251e;
              border: 1px solid #b4251e;
            }
            .type-btn-select {
              color: #b4251e;
              border: 1px solid #b4251e;
            }
          }
          .box-35 {
            color: transparent;
            width: 25px !important;
            height: 20px;
          }
          .type-btns::-webkit-scrollbar {
            display: none; /*隐藏滚动条*/
          }
        }
      }
      .session-list {
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        padding-bottom: 100px;
        .session-box {
          width: 90%;
          padding: 26px 0 30px 0;
          margin-left: calc(5%);
          display: flex;
          //border-bottom: 2px dashed  #999999;
          background-image: url("../../assets/images/cityTravel/foot-img.png");
          background-repeat: no-repeat;
          background-position: left bottom;
          background-size: 100% 2px;
          .img {
            width: 257px;
            height: 164px;
          }
          .detail {
            width: 380px;
            height: 164px;
            margin-left: 16px;
            display: flex;
            flex-direction: column;
            .desc {
              width: 100%;
              .title {
                width: 100%;
                height: 31px;
                font-size: 28px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                font-weight: bold;
                color: #151e26;
                line-height: 30px;
              }
              .icon {
                margin-right: 6px;
              }
              .add-date {
                margin-top: 14px;
                .address {
                  width: 150px;
                  .icon {
                    width: 22px;
                    height: 22px;
                  }
                  .text {
                    font-size: 22px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    line-height: 24px;
                  }
                }
                .date {
                  flex: 1;
                  .icon {
                    width: 20px;
                    height: 20px;
                  }
                  .text {
                    font-size: 22px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    line-height: 24px;
                  }
                }
              }
              .qd-add {
                margin-top: 10px;
                .icon {
                  width: 22px;
                  height: 22px;
                }
                .text {
                  font-size: 22px;
                  padding-right: 6px;
                  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                  font-weight: 400;
                  color: #999999;
                  line-height: 24px;
                }
              }
            }
            .btn {
              flex: 1;
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              .linkDetail {
                display: none;
              }
              .btn-text {
                width: 204px;
                height: 48px;
                opacity: 1;
                font-size: 22px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                background: #999999;
                color: #ffffff;
              }
              .isSignUp {
                background: #b4251e;
              }
            }
          }
        }
      }
      ::v-deep .news-content {
        background-color: #ffffff;
      }
    }
  }
}
</style>
